const toPositiveInteger = (value = null) => {
    const parsed = Number(value);
    return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : null;
};

const toSortOrder = (value = null, fallback = 0) => {
    const parsed = Number(value);
    return Number.isSafeInteger(parsed) && parsed >= 0 ? parsed : fallback;
};

export const normalizeAvatarOptionGroups = (data = {}) => (
    (Array.isArray(data?.anime) ? data.anime : [])
        .map((group, sourceIndex) => {
            const animeId = toPositiveInteger(group?.animeId);
            const characters = (Array.isArray(group?.characters) ? group.characters : [])
                .map((character) => {
                    const characterId = toPositiveInteger(character?.characterId);
                    return {
                        id: `${character?.id || `${animeId || ''}:${characterId || ''}`}`,
                        characterId,
                        name: `${character?.name || ''}`.trim(),
                        image: `${character?.image || ''}`.trim()
                    };
                })
                .filter((character) => character.characterId && character.name && character.image);

            return {
                animeId,
                title: `${group?.title || ''}`.trim(),
                sortOrder: toSortOrder(group?.sortOrder, sourceIndex),
                sourceIndex,
                characters
            };
        })
        .filter((group) => group.animeId && group.title && group.characters.length > 0)
        .sort((left, right) => (
            left.sortOrder - right.sortOrder
            || left.sourceIndex - right.sourceIndex
        ))
        .map((group) => ({
            animeId: group.animeId,
            title: group.title,
            sortOrder: group.sortOrder,
            characters: group.characters
        }))
);
